import {MODULE_NAME} from './slice';

export const selectMessageErr = (state) => state[MODULE_NAME].messageErr;
export const selectBtnLoading = (state) => state[MODULE_NAME].loading;
export const selectToken = (state) => state[MODULE_NAME].token;
export const loginStatus = (state) => ({
    loading: state[MODULE_NAME].loading,
    error: state[MODULE_NAME].messageErr,
  });
